module.exports = __webpack_public_path__ + "img/icon.0fb9d694.png";